export default __webpack_public_path__ + "static/media/3604.02f550dd.png";